import moment from 'moment/moment';
import { SelectOption } from 'global';

import { ReportsListingFilters } from '../../types';

export const GROUP_BY_OPTIONS: SelectOption[] = [
  { label: 'Location', value: 'location_id' },
  { label: 'Salesperson', value: 'sales_representative_id' },
];

export const REPORT_FILTERS: ReportsListingFilters = {
  search: '',
  stageId: '',
  locationId: '',
  departmentId: '',
  salesPersonId: '',
  to: moment().endOf('day'),
  from: moment().subtract(30, 'days').startOf('day'),
};

export const INITIAL_PAGINATION = {
  page: 1,
  perPage: 5,
};
